var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar'),_c('FlashMessage'),_c('v-main',{staticClass:"grey lighten-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }